import React, { Component, ReactNode } from "react";
import { uniqueId } from "src/utils";
import { Label } from "src/components/Label/Label";
import "./ActionMenuCategory.scss";
import ActionMenuItem from "./ActionMenuItem";

interface IActionMenuItem {
    icon?: string;
    key?: string;
    text: string;
    onClick?: () => void;
    href?: string;
    subMenuProps?: any;
    canCheck?: boolean;
    isChecked?: boolean;
}

interface IActionMenuCategory {
    title?: string;
    items: IActionMenuItem[];
}

interface IActionMenuCategoryProps {
    category: IActionMenuCategory;
}

interface IActionMenuCategoryState {
    componentId: string;
}

class ActionMenuCategory extends Component<IActionMenuCategoryProps, IActionMenuCategoryState> {
    constructor(props: IActionMenuCategoryProps) {
        super(props);

        this.state = {
            componentId: uniqueId("ActionMenuCategory")
        };
    }

    public render(): ReactNode {
        const category = this.props.category;
        const componentId = this.state.componentId;

        return (
            <div className="ActionMenuCategory">
                {category.title && (
                    <div className="title">
                        <Label
                            as="span"
                            color="p-mid-grey-2"
                            size="small-2"
                            weight="regular">
                            {category.title}
                        </Label>
                    </div>
                )}
                <div className="items">
                    {category.items.map((item: IActionMenuItem, index: number): ReactNode => {
                        const key = `${componentId}.${index}`;

                        return (
                            <ActionMenuItem
                                item={item}
                                key={key} />
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default ActionMenuCategory;